import axios from "axios";
import qs from "qs";
import { JOIN_COMPANY, SIGNUP } from "../constants/user";
import { fetchCookie } from "../_helpers/utils";

const useGoogleLogin = mod => {
  // Set endpoint for Auth service
  let authEndpoint = `${process.env.API_URL_BASE}/auth/v1/google`;

  // Set endpoint for User service
  let userEndpoint = `${process.env.API_URL_BASE}/users/v1/google/authorize`;

  // Set endpoint for User service
  let userJoinEndpoint = `${process.env.API_URL_BASE}/users/v1/google/join-company/authorize`;

  const axiosRequest = async url => {
    try {
      let response;
      if (mod === JOIN_COMPANY) {
        response = await axios.post(url, null, {
          headers: {
            "X-Auth": "NoAuth",
          },
        });
      } else response = await axios.post(url);
      // Redirect the user to the success URL
      window.location.href = response.data.url;
    } catch (error) {
      console.error(error);
      // Handle error if necessary
    }
  };

  const login = () => {
    let referrerValue = fetchCookie("dh_referrer");

    if (qs.parse(location?.search?.substring(1))?.target) {
      // Check if mod is signup and there is referrer
      if (mod === SIGNUP && referrerValue) {
        window.location.href = `${authEndpoint}?mod=${mod}&target=${
          qs.parse(location.search.substring(1)).target
        }&referrer=${referrerValue}`;
      } else
        window.location.href = `${authEndpoint}?mod=${mod}&target=${qs.parse(location.search.substring(1)).target}`;
    } else {
      // Check if mod is signup and there is referrer
      if (mod === SIGNUP && referrerValue) {
        window.location.href = `${authEndpoint}?mod=${mod}&referrer=${referrerValue}`;
      } else window.location.href = `${authEndpoint}?mod=${mod}`;
    }
  };

  // For Changing sign in method (Switch to Google)
  const switchToGoogle = () => axiosRequest(`${userEndpoint}?mod=${mod}`);

  // For Changing Email
  const changeEmail = () => axiosRequest(`${userEndpoint}?mod=${mod}`);

  // For join Company
  const joinCompany = (invitationToken, companyid) => {
    if (invitationToken) {
      axiosRequest(`${userJoinEndpoint}?invitation_token=${invitationToken}&comp=${companyid}`);
    }
  };

  return { login, switchToGoogle, changeEmail, joinCompany };
};

export default useGoogleLogin;
